import React from 'react';
import { Button } from 'react-bootstrap';
import ExportCSVButton from '../shared-components/ExportButton';

const exportColumns = [
  {
    header: 'Type',
    accessor: profile => (profile.isPrimary ? 'Primary' : 'Sub'),
  },
  {
    header: 'WalletID',
    key: 'walletId',
    forceText: true,
  },
  {
    header: 'PrimaryWalletID',
    key: 'primaryWalletId',
    forceText: true,
  },
  {
    header: 'Status',
    key: 'status',
  },
  {
    header: 'CreatedAt',
    key: 'createdAt',
  },
  {
    header: 'ModifiedAt',
    key: 'modifiedAt',
  },
  {
    header: 'Code',
    accessor: profile => profile.code || '',
    forceText: true,
  },
  {
    header: 'CheckInRef',
    accessor: profile => profile.checkInRefId || '',
    forceText: true,
  },
  {
    header: 'ImportantNote',
    accessor: profile => (profile.status === 'COMPLETED' ? '' : profile.importantReason) ?? '',
  },
];

const Header = ({ onRefresh, profiles }) => {
  return (
    <div className="profile-header d-flex justify-content-between align-items-center p-4 border-bottom">
      <div>
        <div className="game-micro">identity review</div>
        <h4 className="mb-0">KYC Profiles</h4>
      </div>
      <div>
        <Button variant="outline-primary" className="me-2" onClick={onRefresh}>
          <i className="fa fa-sync-alt me-2"></i>
          Refresh
        </Button>
        <ExportCSVButton
          data={profiles}
          columns={exportColumns}
          filename="kyc-profiles.csv"
          number={profiles.length}
        />
      </div>
    </div>
  );
};

export default Header;
